import { render, staticRenderFns } from "./CellItem.vue?vue&type=template&id=117b2e7e&scoped=true&"
import script from "./CellItem.vue?vue&type=script&lang=js&"
export * from "./CellItem.vue?vue&type=script&lang=js&"
import style0 from "./CellItem.vue?vue&type=style&index=0&id=117b2e7e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "117b2e7e",
  null
  
)

export default component.exports